export default __webpack_public_path__ + "static/media/Matsal2.eaae2ecc.jpeg";